import { companyChannelEndpoints } from '../api/apiEndpoint';
import { apiService } from './apiService';

export interface CompanyChannel {
  id: number;
  name: string;
  description: string;
  order: number;
  url?: string;
  code: string;
  isActive: boolean;
  company: {
    id: number;
    name: string;
    description: string;
    logo?: {
      id: number;
      name: string;
      url: string;
    };
  };
  template?: {
    id: number;
    name: string;
    type: string;
    content: any;
  };
}

class CompanyChannelService {
  /**
   * 채널 ID로 채널 정보 조회
   */
  async getChannelById(id: number): Promise<CompanyChannel | null> {
    try {
      const response = await apiService.get<CompanyChannel>(
        companyChannelEndpoints.getChannelById(id)
      );
      return response;
    } catch (error) {
      console.error('Failed to get channel by id:', error);
      return null;
    }
  }

  /**
   * 채널 코드로 채널 정보 조회
   */
  async getChannelByCode(code: string): Promise<CompanyChannel | null> {
    try {
      const response = await apiService.get<CompanyChannel>(
        companyChannelEndpoints.getChannelByCode(code)
      );
      return response;
    } catch (error) {
      console.error('Failed to get channel by code:', error);
      return null;
    }
  }
}

export const companyChannelService = new CompanyChannelService(); 